export const GET_DISCOUNT_RULES = 'GET_DISCOUNT_RULES';
export const UPDATE_DISCOUNT_RULES = 'UPDATE_DISCOUNT_RULES';
export const SAVE_DISCOUNT_RULE = 'SAVE_DISCOUNT_RULE';
export const DELETE_DISCOUNT_RULE = 'DELETE_DISCOUNT_RULE';
export const SET_DISCOUNT_RULES_LOADING = 'SET_DISCOUNT_RULES_LOADING';
export const SHOW_CREATE_DISCOUNT_RULE_MODAL =
  'SHOW_CREATE_DISCOUNT_RULE_MODAL';
export const SHOW_EDIT_DISCOUNT_RULE_MODAL = 'SHOW_EDIT_DISCOUNT_RULE_MODAL';
export const SHOW_EDITOR_MODAL_LOADING = 'SHOW_EDITOR_MODAL_LOADING';
export const SET_EDITOR_ERROR_MESSAGE = 'SET_EDITOR_ERROR_MESSAGE';
export const SHOW_DELETE_CONFIRMATION_MODAL = 'SHOW_DELETE_CONFIRMATION_MODAL';

export const DISCOUNT_RULE_LOG_SET_SHOWN = 'DISCOUNT_RULE_LOG_SET_SHOWN';
export const DISCOUNT_RULE_DO_SHOW_LOG = 'DISCOUNT_RULE_DO_SHOW_LOG';
export const DISCOUNT_RULE_LOG_CHANGE_PAGE = 'DISCOUNT_RULE_LOG_CHANGE_PAGE';
export const DISCOUNT_RULE_LOG_SET_DATA = 'DISCOUNT_RULE_LOG_SET_DATA';
export const DISCOUNT_RULE_LOG_SET_IS_LOADING =
  'DISCOUNT_RULE_LOG_SET_IS_LOADING';
export const DISCOUNT_RULE_LOG_SET_ERRORS = 'DISCOUNT_RULE_LOG_SET_ERRORS';
